import React from 'react';
import { UseFormRegister } from 'react-hook-form';

interface TitleInputProps {
  register: UseFormRegister<any>;
  disabled?: boolean;
  error?: string;
}

const TitleInput: React.FC<TitleInputProps> = ({
  register,
  disabled = false,
  error,
}) => {
  return (
    <div>
      <label>내용</label>
      <input
        id="title"
        type="text"
        className="w-full"
        placeholder="간단한 내용을 입력하세요"
        // 웹에서는 입력 필수
        {...register('title', { required: '내용을 입력해주세요', maxLength: { value: 16, message: '최대 16자까지 입력할 수 있습니다.' } })}
        disabled={disabled}
        onKeyDown={(e) => {
          // IME 입력 중일 때는 처리하지 않음
          if (e.nativeEvent.isComposing) {
            return;
          }
          
          if (e.key === 'Enter' || e.key === 'Tab') {
            e.preventDefault();
            e.currentTarget.blur();
          }
        }}
        onFocus={(e) => {
          e.currentTarget.select();
        }}
      />
      {error && <p className="mt-1 ml-2 text-sm text-red-500">{error}</p>}
    </div>
  );
};

export default TitleInput; 